<template>
	<div class="business-article">
		<div class="column">
			<div class="content">
				<div class="content-inner u-pt4em-pc">
					<p class="content-catch u-MT2em-sp">
						ソフトウェア工学のノウハウを駆使して、最上流の課題設定から定着のための教育まで、全てを担う
					</p>
					<div class="content-text">
						<p>
							ビジネスプラットフォーム領域の特長は、最上流の「課題設定」から、クライアント企業の現場の教育まで含めた「定着」までを、一気通貫で担うことです。クライアントからの要望をそのまま請けるのではなく、経営や事業の状況をもとに課題を設定し、クライアントとともにシステムの仕様を詰めていきます。
						</p>
						<p>
							自社のアーキテクトがクライアント企業のエンジニアと共にシステムのアーキテクチャを描き、その後の開発を進める中で、システム構築を支援。さらに、提供したシステムが現場でフルに活用され、保守までを担保できるように、クライアントのエンジニアの教育も担います。「コンサルティングで終わり」「システムの構築で終わり」ではありません。提供したシステムが機能し、クライアントの事業が継続的に成長することをゴールに置いた、より本質的な仕事ができます。
						</p>
						<p>
							この一連のプロセスの中で重要な役割を占めるのが、UMLやドメイン駆動設計、アジャイルプロセス、クラウドネイティブ、AI活用といった「世界標準」の工学的な技術です。クライアントのビジネスの核心価値を理解し、「何をつくるべきか」を明確にし、効率の良い開発業務を推進しています。
						</p>
					</div>
				</div>
			</div>
		</div>
		<!-- ビジネスプラットフォーム領域の強み -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					ビジネスプラットフォーム領域の強み
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt6em-pc">
					<div class="content-lead">
						<div class="content-num content-num--1">
							<img src="../../assets/common/num01.svg" alt="1" width="51" height="52" />
						</div>
						<p class="content-catch">事業会社の「IT内製化」を<br class="under_display" />中長期で支援</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							クライアントである事業会社が、この変化が激しい時代に生き残るためには、「ITの内製化」が不可欠になっています。従来のように外部のIT組織にシステムを発注していたのでは、変化のスピードに対応できないからです。そこで、ビジネスプラットフォーム領域のコンサルタントは、事業会社の業務を分析しコア業務を抽出することで、様々な先端ソリューションを提供。ITによる内製化を中長期で支援しています。
						</p>
					</div>
					<div class="content-lead">
						<div class="content-num">
							<img src="../../assets/common/num02.svg" alt="2" width="62" height="52" />
						</div>
						<p class="content-catch">「コンサルティング→開発→教育」を<br class="under_display" />一気通貫で提供</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							「私たちがいなくなっても、クライアント企業が独自でITに関する判断ができるようになる」「クライアント企業がテクノロジーを活用して利益を上げることができる」状態を、私たちはゴールに置いています。その実現のために、コンサルティングから始まり、クライアント企業内の現場エンジニアに対する教育サービスを展開。教育の専門チームが、お客様の習熟度に合わせたプログラムを提供しています。
						</p>
					</div>
					<div class="content-lead">
						<div class="content-num">
							<img src="../../assets/common/num03.svg" alt="3" width="63" height="52" />
						</div>
						<p class="content-catch">
							高い技術の目利き力
						</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							組織内にR&Dの専門部隊を設置。世の中のトレンドを読みながら、国内外の技術情報を収集しています。お客様の事業課題の解決にマッチする技術を選定し、独自のソリューションに落とし込んで提供できます。むやみに最先端を追い求めるのではなく、中長期での活用が可能で、拡張性に長けた技術を選定することが多いです。豆蔵は独立系のコンサルティング企業のため、フラットに技術を評価できるのも強みの一つです。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 代表的なプロジェクト事例 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					代表的なプロジェクト事例
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pb5em-pc">
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--1">
								<img src="../../assets/business_platform/icon_heart.svg" alt="" width="70" height="61" />
							</div>
							<p class="content-iconText">
								大手保険企業
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								メインフレームからオープン系への移行を、<br class="over_display" />教育も併せて推進
							</p>
							<p>
								メインフレームからオープン系のプラットフォームへの大改修をリードしました。アーキテクチャの設計支援と、システムを組織に根付かせるための教育をセットで提供することで、クライアント企業の「IT内製化」を推進。ただし、メインフレームとオープン系では、開発のスタンスが大きく異なります。クライアント企業内の現場エンジニアに対し、業務モジュールベースの考え方や業務範囲の変化などについて、幅広くインプットさせていただきました。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--1">
								<img src="../../assets/business_platform/icon_card.svg" alt="" width="74" height="54" />
							</div>
							<p class="content-iconText">
								大手金融系企業
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">「20年に一度の大改修」と言われた<br class="over_display" />基幹システムの刷新</p>
							<p>
								ホスト系からWeb系へとシステムを移行し、ユーザビリティを大きく改善した事例です。あらゆるサービスの顧客情報を一元管理できるようになり、クライアントから高い評価をいただいています。ポイントは、技術力、課題解決力の高い自社チームを組織し、スキルトランスファーを丁寧に行ったこと。クライアント側の開発力や運用力を向上させることで、業務改善に大きく貢献できました。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--1">
								<img src="../../assets/business_platform/icon_call.svg" alt="" width="65" height="80" />
							</div>
							<p class="content-iconText">
								大手コールセンター
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								カスタマー対応の自動化および応対品質向上
							</p>
							<p>
								CTI（Computer Telephony
								Integration：電話とコンピュータが統合されたシステム）連携を実現しました。お客様対応の窓口に入電した電話番号から新規/再入電を判別しつつ、過去の事例から適切な回答を抽出することで、電話と応対品質を向上。訪問/出動を伴うお問い合わせは、出動するパートナーを自動で指定することでオファーを自動化しました。オペレーション効率が向上して、削減された工数をよりクリエイティブなタスクに充当することで、コールセンター業務の進化に貢献。2020年にシステムの稼働を開始した後、別の事業部のコールセンターへと展開しています。
							</p>
						</div>
					</div>
				</div>
			</div>
		</article>
		<!-- ビジネスプラットフォーム領域の組織構成 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					ビジネスプラットフォーム領域の組織構成
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt5em-pc u-pb55em-pc">
					<div class="content-text u-mt0">
						<p class="content-text lg u-font-ots ">
							コンサルティングチーム、アジャイルチーム、<br class="over_display" />R&Dチーム、教育チームで構成
						</p>
						<p>
							ビジネスプラットフォーム領域は、以下の4つの組織に分かれています。それぞれがフラットにつながり、クライアントに複合的な価値を提供しています。エンジニア個人のキャリアとし、複数のチームを経験することも可能です。コンサルティングの現場とR&D系組織の双方に身を置くことで、自身のスキルの幅を広げられます。
						</p>
					</div>
				</div>
				<div class="grayBoxContainer">
					<section class="content-inner grayBox">
						<h4 class="grayBox_title">
							コンサルティングチーム
						</h4>
						<p class="grayBox_desc">
							クライアントに向き合い、コンサルティングサービスを提供するチームです。お客様の特性や支援内容で、大きく4つのグループに分かれています。それぞれのグループが有機的につながり、事例などを頻繁に共有しているので、組織の壁を感じることはありません。また、各グループのリーダーがチームをマネージメントしていますが、「上司と部下」という関係ではなくエンジニア同士のフラットな関係です。
						</p>
					</section>
					<section class="content-inner grayBox">
						<h4 class="grayBox_title">
							アジャイルチーム
						</h4>
						<p class="grayBox_desc">
							ビジネスプラットフォーム領域の案件は、100%アジャイルで開発しています。その開発手法を専門に研究し、それぞれの現場に根付かせるのがアジャイルチームの役割です。スクラムを盲目的に推進するのではなく、各現場に必要な要素をインプットして効率化することを心掛けています。組み込み開発やAIを専門に扱う他事業部との合同勉強会も開催。豆蔵という会社全体で、開発プロセスに磨きを掛けています。
						</p>
					</section>
					<section class="content-inner grayBox">
						<h4 class="grayBox_title">
							R&Dチーム
						</h4>
						<p class="grayBox_desc">
							中長期のトレンドを予測しながら、国内外の技術情報を収集して現場に実装することが、R&Dチームのミッションです。自社で最新技術を試し、クライアント企業に提案できる技術かどうかを見極めるための「ドッグフーディング」も数多く行っています。この取り組みによって、社内の多くのタスクが自動化されました。また、社外に対する「技術発信」も担っています。<a
								class="u-external"
								href="https://developer.mamezou-tech.com/"
								target="_blank"
								>「豆蔵デベロッパーサイト」</a
							>で知見を提供し、技術コミュニティに還元するのも重要な役割です。
						</p>
					</section>
					<section class="content-inner grayBox">
						<h4 class="grayBox_title">
							教育チーム
						</h4>
						<p class="grayBox_desc">
							クライアント内の現場エンジニアに対し、様々な教育プログラムを提供し「ITの内製化」を推進するチームです。新卒向け、2〜3年目の若手エンジニア向けのプログラム、上級エンジニア向けのアーキテクト設計講習、スクラム・テスト駆動開発（TDD）などの開発プロセス関係の講座、事業会社のユーザー部門向けプログラムも展開しています。
						</p>
					</section>
				</div>
			</div>
		</article>
		<!-- 今後の展望 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					今後の展望
				</h3>
			</div>
			<div class="image">
				<img src="../../assets/business_platform/photo01.jpg" alt="" width="1840" height="600" />
			</div>
			<div class="content">
				<div class="content-inner underImage u-pb3em-pc">
					<p class="content-catch">
						より高次の課題にアプローチしていく
					</p>
					<div class="content-text u-mt2em-pc">
						<p>
							ビジネスプラットフォーム領域のミッションは、クライアント企業の「IT内製化」を推進すること。このミッションには、終わりがありません。システムを稼働させて内製化が浸透したとしても、必ず新たな課題が生じます。その課題に対し、さらに高度なサービスや知見を提供するのが私たちの役目です。
						</p>
						<p>
							業務フローを描き、流れているデータやオブジェクトを把握し、モデリング技術によって普遍的な箇所を抽出。解決のための仮説を立てて実行し、その結果を再度検証する。一連の流れは変わりませんが、仮説検証のサイクルを重ねることによって、アプローチできる課題がより高次になっていく。そのスパイラルを回していくことで、クライアント企業の事業成長を実現する。そのような成功事例を増やすことで、日本のIT業界を変えていきたいと考えています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 求める人物像 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					求める人物像
				</h3>
			</div>
			<div class="content">
				<div class="content-inner bgGray u-pt4em-pc">
					<p class="content-catch">
						技術への探究心を持っている人、<br class="over_display" />クライアント企業に技術力を還元できる人。
					</p>
					<div class="content-text u-mt3em-pc">
						<p>
							ビジネスプラットフォーム領域が求める人物像は、「技術に対する飽くなき探究心を持っている人」です。開発技術にとどまらず、開発プロセスやソフトウェアエンジニアリングに対して興味を持っている人は、その志向を存分に発揮できます。豆蔵の最大の強みは技術力です。クライアント企業からも高い技術力を活かしたソリューションが期待されていますし、社内にも技術力・技術熱の高いエンジニアが多数在籍しています。
						</p>
						<p>
							そして、もう1つの人物像は、「クライアント企業の価値への還元を考えられる人」。クライアント企業からの要望を受け、それに添ったシステムを開発するだけでは、いいモノは作れません。要望への対応ではなく価値の実現を叶えることが、豆蔵の役割です。クライアント企業の事業に一歩踏み込んで、自身の技術力を活かせる人を求めています。多様なプロジェクトへのアサインを通じ、より市場価値の高いエンジニアへと成長できます。
						</p>
						<p>
							なお、ビジネスプラットフォーム領域としての行動規範を以下で公開しています。システム開発における豆蔵のアプローチを説明した上で、豆蔵のエンジニアがプロジェクトを支援する意義を具体的にイメージできますので、是非ご一読ください。
						</p>
						<p>
							<a
								class="u-external"
								href="https://www.mamezou.com/techinfo/otherwise/techinfo/otherwise/code-conduct-1"
								target="_blank"
								>Code of Conduct (行動規範)</a
							>
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 活躍事例 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner u-ls10-pc">
					活躍事例
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt65em-pc">
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Aさん
							</p>
						</div>
						<div class="content-text u-mt0">
							<p class="u-mt0-pc">
								大学教員として情報通信技術に関する研究やプログラミング系講座の講師を担当したのち、プログラミング教育により重点的に取り組みたいとの思いから豆蔵へ入社。以来、オンライン研修の設計や、新人研修および中途社員向けのプログラミング研修講師として、大手上場企業やそのグループ会社における教育に携わっています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Bさん
							</p>
						</div>
						<div class="content-text u-mt0">
							<p class="u-mt0-pc">
								SIer出身。スクラムマスターもしくはアジャイル開発のコーチ・マネージャーの仕事をしたいと豆蔵に入社。以来、アジャイル開発の各種方法論を活用し、社内外のプロダクト開発において、主にスクラムの導入・推進に従事。チーム・組織へのアジャイル精神の啓蒙やピープルマネージメントなど、エンジニアのサポートとプロセス面のリードに徹しています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Cさん
							</p>
						</div>
						<div class="content-text u-mt0">
							<p class="u-mt0-pc">
								前職では、金融機関向けパッケージシステムの開発に従事。技術的な停滞を感じ、自身のスキルアップのために豆蔵に入社。顧客折衝～開発、テストまで幅広く経験し、AWS等のインフラも一部担当。ここ数年は、社員同士のコミュニケーション不足の解消やスキルアップを目的とし、社内勉強会を定期的に開催しています。
							</p>
						</div>
					</div>
				</div>
			</div>
		</article>
		<!-- キーマンインタビュー１ -->
		<article class="column keyman">
			<div class="keyman_flex">
				<h3 class="keyman_title">
					<span class="top"
						>キーマンインタビュー<img src="../../assets/common/num01_white.svg" alt="1" width="22" height="23"
					/></span>
					<span class="mid">アジャイルの本質は<br />失敗できること</span>
					<span class="bottom">事業部長：Yoshihisa</span>
				</h3>
				<div class="keyman_image">
					<img src="../../assets/business_platform/photo02.jpg" alt="" width="1260" height="761" />
				</div>
			</div>
			<div class="content u-bg0-pc">
				<div class="content-inner underImage">
					<div class="content-text --interview u-mt0">
						<p class="u-mt0">
							前々職ではガジェットのレビューサイトの企画・開発・記事執筆・経営のすべてを実施していました。モチベーションの高い優秀なメンバーに囲まれ、一人では決してできない成果物をチーム一丸となって作り上げたいとの想いで豆蔵へ2007年に転職。アーキテクトとして12年ほど現場一筋でクライアント企業を支援。2019年より執行役員
							兼 事業部長としてマネージメントを担っています。
						</p>
						<p>
							事業売上の90%以上は大手上場企業やそのグループ会社とのプライム案件であり、エンドユーザーの声を直接伺いながら支援するやりがいのある案件ばかりです。クライアント企業と共に成長できる環境といえます。
						</p>
						<p>
							IT技術や開発手法に対して好奇心を持ったエンジニアたちと、フラットな関係性のもとで働けます。私のことを「事業部長」や「執行役員」と呼ぶ社員は一人もいません。<br />また、開発プロセスは100%アジャイルで、その本質は「失敗できること」と考えています。早めに失敗して早めにやりなおせばいい。言いたいことを言える環境で、迷いなく技術の深淵にチャレンジして欲しいですね。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- キーマンインタビュー２ -->
		<article class="column keyman">
			<div class="keyman_flex">
				<h3 class="keyman_title">
					<span class="top"
						>キーマンインタビュー<img src="../../assets/common/num02_white.svg" alt="1" width="28" height="23"
					/></span>
					<span class="mid">得意領域の異なる人材を<br />プロジェクトにアサイン</span>
					<span class="bottom">グループリーダー：Shinji</span>
				</h3>
				<div class="keyman_image">
					<img src="../../assets/business_platform/photo03.jpg" alt="" width="1260" height="760" />
				</div>
			</div>
			<div class="content u-bg0-pc">
				<div class="content-inner underImage">
					<div class="content-text --interview u-mt0">
						<p class="u-mt0">
							前職はユーザー企業のシステム開発部門にて、開発・保守に従事していました。利用者視点では無駄な仕様の実装を多く強いられ、根本の要求からメスを入れていかなければならないと感じ、「要求開発」という命題を掲げていた豆蔵に感銘を受けて2005年に転職。システムの企画段階から要求開発に参画し、要件定義、開発、運用支援までプレイングマネージャとしてお客様のビジネスを支援しています。
						</p>
						<p>
							私は大手コールセンターのプロジェクトをマネージメントしています。若手を中心に、得意領域の異なるメンバーをアサインすることで、切磋琢磨して成長できる環境を整えています。また、業務分析から課題設定までの一連の流れを全員に共有することで、ブレずに目の前のタスクに集中できていますね。
						</p>
					</div>
				</div>
			</div>
		</article>

		<article class="column linkBox">
			<router-link to="/people_tadahiro">
				<h3 class="linkBox_title">
					ビジネスプラットフォーム領域<span class="over_display --inline">：</span
					><br class="under_display" />インタビュー記事はこちら
				</h3>
				<div class="linkBox_inner">
					<p class="linkBox_text u-font-ots">
						クライアントの課題の根幹を<br />明らかにすることで、<br />システムは真の目的を達成できる。
					</p>
					<picture class="linkBox_bg">
						<source srcset="../../assets/business_platform/photo04_pc.jpg" media="(min-width: 1161px)" />
						<img src="../../assets/business_platform/photo04_sp.jpg" alt="" />
					</picture>
				</div>
			</router-link>
		</article>
	</div>
</template>

<script>
// @ is an alias to /src
// import News from '@/components/News.vue';
export default {
	name: 'business-platform-article',
};
</script>

<style lang="scss" scoped>
// * {
// 	color: red !important;
// }
@keyframes gradientAnime {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
.business-article {
	max-width: 920px;
	width: 100%;
	position: relative;
	margin: 0 auto;
	margin-bottom: 100px;
}
.column {
	position: relative;
	margin: 0 auto;
	margin-bottom: 140px;
	@media print, screen and (max-width: 1160px) {
		width: 90%;
		margin-bottom: 100px;
	}
	&:after {
		content: '';
		width: 150%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// top: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:before {
		content: '';
		width: 100%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// bottom: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:nth-child(1) {
		&:after {
			content: none;
			// width: 150%;
			// top: 0;/
			// transform-origin: left top;
		}
		&:before {
			content: none;
			// width: 100%;
			// bottom: 0;
			// transform-origin: left top;
			// left: -50%;
		}
	}
	// ビジネスプラットフォーム領域の強み
	&:nth-child(2) {
		&:after {
			width: 150%;
			// top: 30%;
			// transform-origin: left top;
			// width: 100vw;
			top: -10%;
			left: -10%;
			transform-origin: left top;
			@media print, screen and (min-width: 920px) {
				top: 5%;
				left: 0;
			}
		}
		&:before {
			// width: 100%;
			// bottom: -20%;
			// transform-origin: left top;
			// left: -50%;
			width: 150%;
			bottom: -5%;
			transform-origin: left top;
			left: -10%;
			@media print, screen and (min-width: 920px) {
				transform-origin: right top;
				left: auto;
				right: 1px;
				bottom: 15%;
				width: 100vw;
			}
		}
	}
	// 代表的なプロジェクト事例
	&:nth-child(3) {
		&:after {
			content: none;
		}
		&:before {
			content: none;
		}
	}
	// ビジネスプラットフォーム領域の組織構成
	&:nth-child(4) {
		&:after {
			width: 150%;
			top: -10%;
			left: -10%;
			transform-origin: left top;
			@media print, screen and (min-width: 920px) {
				top: 5%;
				left: 0;
			}
		}
		&:before {
			content: none;
		}
	}
	// 今後の展望
	&:nth-child(5) {
		&:after {
			content: none;
		}
		&:before {
			width: 150%;
			bottom: -5%;
			transform-origin: left top;
			left: -10%;
			@media print, screen and (min-width: 920px) {
				transform-origin: right top;
				left: auto;
				right: 1px;
				bottom: 15%;
				width: 100vw;
			}
		}
	}
	// 求める人物像
	&:nth-child(n + 6) {
		&::after {
			content: none;
		}
		&:before {
			content: none;
		}
	}
}

.column.keyman {
	@media print, screen and (min-width: 1161px) {
		margin-bottom: 0;
	}
	& + .column.keyman {
		@media print, screen and (min-width: 1161px) {
			margin-top: 60px;
		}
	}
	.content-inner {
		@media print, screen and (min-width: 1161px) {
			padding-bottom: 0;
		}
	}
	.keyman_flex {
		display: flex;
		flex-direction: column;
		align-items: center;
		@media print, screen and (min-width: 1161px) {
			flex-direction: row;
			align-items: flex-end;
		}
	}
	.keyman_title {
		display: flex;
		flex-direction: column;
		gap: 1em;
		position: relative;
		z-index: 1;
		width: 80vw;
		margin: 0;
		padding: 2em 0 2em 2em;
		box-sizing: border-box;
		font-family: 'ots-mincho', serif;
		background-color: #543193;
		color: #fff;
		@media print, screen and (min-width: 1161px) {
			justify-content: center;
			width: 380px;
			flex: 0 0 380px;
			padding: 2em 0 2em 3em;
			margin-bottom: 40px;
			margin-right: -90px;
		}
		span {
			display: block;
			img {
				display: block;
				width: 16px;
				@media print, screen and (min-width: 1161px) {
					width: 22px;
				}
			}
		}
		.top {
			display: flex;
			align-items: center;
			font-size: 12px;
			gap: 1em;
			font-weight: normal;
			@media print, screen and (min-width: 1161px) {
				font-size: 16px;
				letter-spacing: -0.05em;
			}
		}
		.mid {
			font-size: 19px;
			line-height: calc(70 / 38);
			font-weight: normal;
			letter-spacing: 0;
			@media print, screen and (min-width: 1161px) {
				letter-spacing: -0.05em;
				font-size: 26px;
				line-height: calc(50 / 26);
			}
		}
		.bottom {
			font-weight: bold;
			font-size: 12px;
			font-family: 'Noto Sans JP', sans-serif;
			letter-spacing: 0.1em;
			@media print, screen and (min-width: 1161px) {
				font-size: 14px;
			}
		}
	}
	.keyman_image {
		position: relative;
		z-index: 0;
		margin: -20px calc(50% - 50vw) 0;
		width: 100vw;
		@media print, screen and (min-width: 1161px) {
			flex: 0 0 630px;
			width: 630px;
			margin: 0;
		}
		img {
			vertical-align: bottom;
		}
	}
}
.title-wrap {
	top: -1.5em;
	display: inline-block;
	background-color: #543193;
	color: #fff;
	margin: 0;
	position: absolute;
	@media print, screen and (max-width: 1160px) {
		top: -30px;
		font-size: 12px;
	}
	h3 {
		font-family: 'ots-mincho';
		padding: 0 2em;
		text-align: left;
		position: relative;
		letter-spacing: 0.05em;
		font-weight: normal;
		@media print, screen and (min-width: 1161px) {
			padding: 0 3.5em;
			font-size: 16px;
			letter-spacing: 0;
		}
		&:before {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			left: 0;
		}
		&:after {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			right: 0;
		}
	}
}
.image {
	margin: 0 calc(50% - 50vw);
	width: 100vw;
	height: 32.67vw;
	@media print, screen and (min-width: 1160px) {
		margin: 0;
		width: 100%;
		height: 300px;
	}
	img {
		vertical-align: middle;
	}
}
.content {
	background-color: #fff;
}
.content-inner {
	padding: 120px 100px 3.5em 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 80px 5% 50px 5%;
	}
	&.grayBox {
		padding-top: 2.5em;
		padding-bottom: 1.5em;
		background-color: #e7e7e7;
		@media print, screen and (min-width: 1161px) {
			padding: 3em 50px;
		}
	}
	&.underImage {
		padding: 50px 100px 100px 100px;
		@media print, screen and (max-width: 1160px) {
			padding: 40px 5% 50px 5%;
		}
	}
	&.bgGray {
		background-color: #e7e7e7;
	}
}

.grayBoxContainer {
	display: flex;
	flex-direction: column;
	gap: 40px;
	@media print, screen and (min-width: 1161px) {
		flex-wrap: wrap;
		flex-direction: row;
		gap: 5px;
	}
}

.grayBox {
	position: relative;
	@media print, screen and (min-width: 1161px) {
		flex: 0 1 calc(50% - 5px);
		box-sizing: border-box;
	}
	&_title {
		display: inline-block;
		position: absolute;
		top: -1.5em;
		left: 50%;
		transform: translateX(-50%);
		background-color: #543193;
		width: 230px;
		padding: 1em 0;
		margin: 0;
		color: #fff;
		font-size: 12px;
		font-weight: bold;
		text-align: center;
		line-height: 1;
		letter-spacing: 0.05em;
		white-space: nowrap;
		@media print, screen and (min-width: 1161px) {
			box-sizing: border-box;
			width: 260px;
			font-size: 13px;
			padding: 1em 0;
		}
	}
	&_desc {
		font-size: 12px;
		line-height: 2;
		text-align: justify;
		text-justify: inter-ideograph;
		text-justify: inter-character;
		font-weight: 500;
		@media print, screen and (min-width: 1161px) {
		}
	}
}

.content-lead {
	&:not(:first-of-type) {
		margin-top: 4em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 3em;
		}
	}
	@media print, screen and (min-width: 1161px) {
		display: flex;
		align-items: center;
		gap: 40px;
	}
}

.content-num {
	width: 31px;
	@media print, screen and (min-width: 1161px) {
		width: 37px;
	}
	&--1 {
		width: 25px;
		@media print, screen and (min-width: 1161px) {
			width: 30px;
		}
	}
	img {
		width: 100%;
	}
}

.content-iconFlex {
	@media print, screen and (min-width: 1161px) {
		display: flex;
		justify-content: flex-end;
		gap: 50px;
		.content-text {
			flex: 0 0 530px;
		}
	}
	& + & {
		margin-top: 4em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 3em;
		}
	}
	&.--person {
		@media print, screen and (min-width: 1161px) {
			gap: 50px;
		}
	}
}
.content-iconFlex.--person + .content-iconFlex.--person {
	@media print, screen and (min-width: 1161px) {
		margin-top: 2.5em;
	}
}

.content-iconContainer {
	display: flex;
	align-items: center;
	gap: 30px;
	@media print, screen and (min-width: 1161px) {
		flex: 1 1 auto;
		gap: 10px;
		flex-direction: column;
	}
	&.--person {
		gap: 0;
		flex-direction: column;
		margin-bottom: 1em;
		@media print, screen and (min-width: 1161px) {
			margin-bottom: 0;
		}

		.content-icon {
			@media print, screen and (min-width: 1161px) {
				width: 55px;
				margin-top: 5px;
			}
		}
	}
}
.content-icon {
	width: 50px;
	@media print, screen and (min-width: 1161px) {
		width: 70px;
	}
}

.content-iconText {
	font-size: 12px;
	font-weight: bold;
	margin: 0;
	@media print, screen and (min-width: 1161px) {
		font-size: 14px;
	}
}

.content-catch {
	font-size: 26px;
	font-family: 'ots-mincho', serif;
	letter-spacing: 0;
	margin: 0;
	line-height: calc(61 / 26);
	@media print, screen and (max-width: 1160px) {
		margin-top: 0.5em;
		font-size: 18px;
		line-height: calc(68 / 36);
	}
}
.content-text {
	margin-top: 4em;
	font-size: 12px;
	text-align: justify;
	// @media print, screen and (min-width: 1161px) {
	// 	margin-top: 4em;
	// }
	&.--interview p {
		@media print, screen and (min-width: 1161px) {
			font-size: 14px;
			line-height: calc(30 / 14);
		}
	}
	p {
		font-family: 'Noto Sans JP', sans-serif;
		font-weight: 500;
	}
	p:not(:first-of-type) {
		margin-top: 2.5em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 2em;
		}
	}
	p.content-textLead {
		font-family: 'ots-mincho', serif;
		font-size: 18px;
		line-height: calc(68 / 36);
		letter-spacing: 0;
		margin-top: 1.5em;
		@media print, screen and (min-width: 1160px) {
			margin-top: -0.5em;
			font-size: 23px;
			line-height: calc(41 / 23);
		}
	}
	p.lg {
		font-family: 'Noto Serif JP', serif;
		font-size: 18px;
		line-height: calc(68 / 36);
		letter-spacing: 0;
		margin-top: 0;
		@media print, screen and (min-width: 1160px) {
			font-size: 26px;
			line-height: calc(61 / 26);
		}
	}
}
.case {
	background-color: #dddddd;
}
.case-inner {
	padding: 0 100px 50px 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 0 5% 50px 5%;
	}
}
.case-title {
	font-size: 14px;
	background-color: #543193;
	color: #fff;
	display: inline-block;
	margin: 0;
	padding: 0 30px;
}
.case-text {
	font-size: 12px;
	margin-top: 40px;
	text-align: justify;
}
.case-catch {
	font-size: 17px;
}

.linkBox {
	@media print, screen and (min-width: 1161px) {
		margin-top: 140px;
		max-width: 830px;
	}
	&_title {
		display: inline-block;
		position: relative;
		margin: 0;
		padding: 1em 2em 1em 2.5em;
		background-color: #e7e7e7;
		color: #543193;
		font-weight: bold;
		font-size: 11.5px;
		line-height: calc(40 / 23);
		letter-spacing: 0.05em;
		@media print, screen and (min-width: 1161px) {
			font-size: 13px;
		}
		&::before {
			content: '';
			display: inline-block;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 1em;
			height: 2px;
			background-color: currentColor;
		}
	}
	&_inner {
		position: relative;
	}
	&_text {
		position: absolute;
		top: 50%;
		left: 1.5em;
		transform: translateY(-50%);
		margin: 0;
		font-family: 'Noto Serif JP', serif;
		color: #fff;
		letter-spacing: 0;
		font-size: 15px;
		line-height: calc(64 / 30);
		@media print, screen and (min-width: 1161px) {
			left: 3.5em;
			font-size: 24px;
			line-height: calc(53 / 24);
			letter-spacing: -0.1em;
		}
	}
	&_bg {
		display: block;
		source,
		img {
			vertical-align: bottom;
		}
	}
}

.u-mt0-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 0 !important;
	}
}

.u-bg0-pc {
	@media print, screen and (min-width: 1161px) {
		background-color: transparent !important;
	}
}

.u-mt0-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 0 !important;
	}
}
.u-mt2em-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 2em !important;
	}
}
.u-mt3em-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 3em !important;
	}
}
.u-pb3em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 3em !important;
	}
}
.u-pt4em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 4em !important;
	}
}
.u-pt5em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 5em !important;
	}
}
.u-pb5em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 5em !important;
	}
}
.u-pb55em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 5.5em !important;
	}
}
.u-pt6em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 6em !important;
	}
}
.u-pt65em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 6.5em !important;
	}
}
.u-pt7em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 7em !important;
	}
}

.u-ls10-pc {
	letter-spacing: 0.1em !important;
}
</style>
